import { createSelector } from 'reselect'
import { equalId } from '../../utils/id'
import { State } from '../index'

const internalGetSelectedSpeaker = (state: State) => {
  return state.editor.selectedSpeaker
}

const internalGetSelectedTag = (state: State) => {
  return state.editor.selectedTag
}

const internalGetParagraphs = (state: State) => {
  return state.transcript.paragraphs
}

export const getFoundParagraphIds = createSelector(
  [internalGetSelectedSpeaker, internalGetSelectedTag, internalGetParagraphs],
  (selectedSpeaker, selectedTag, paragraphs) => {
    if (!selectedTag) {
      return []
    }

    return Object.values(paragraphs)
      .filter((paragraph) => {
        if (selectedSpeaker && !equalId(paragraph.speakerId, selectedSpeaker)) {
          return false
        }

        return paragraph.tagIds.includes(selectedTag)
      })
      .map((paragraph) => paragraph.id)
  },
)
